import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="3 2 18 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9.5 9.5C9.5 8 10.5 7.5 12 7.5C14.2091 7.5 15.5 8.34315 15.5 10C15.5 11.3994 14.2282 12.1685 12.5 12.5C11.6943 12.6546 11.5 13.5 12 14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" />
    <circle cx="12" cy="17" r="1" fill="currentColor" />
  </svg>
);
